module.exports = __webpack_public_path__ + "31793e5dbe8c9d6e3fc3554bb54769fb.MP3";